<template>
	<div>
		<div class="row">
			<div class="col-sm-12">
				<ul class="uk-breadcrumb">
					<li><a href="/">{{ $t('home') }}</a></li>
					<li><span>{{ $t('global.roles') }}</span></li>
				</ul>
			</div>
		</div>

		<div id="roles_toolbar" class="toolbar">
			<button id="roles_table_toolbar_add" :title="$t('create')">
				<span uk-icon="plus"></span>
				<span class="title">{{ $t('create') }}</span>
			</button>
			<button id="roles_table_toolbar_remove" :title="$t('delete')">
				<span uk-icon="trash"></span>
				<span class="title">{{ $t('delete') }}</span>
			</button>
		</div>

		<div class="table_search_phrase">
			<div id="phase" class="uk-search uk-search-default">
				<a class="uk-search-icon-flip" uk-search-icon></a>
				<input class="uk-search-input uk-form-small" type="text" :placeholder="$t('search')">
				<span class="search_reset fa fa-times" tabindex="-1"></span>
			</div>
		</div>

		<div class="row table-area-row">
			<div class="col-sm-12 table-area-col">
				<table id="table" class="table"></table>
			</div>
		</div>

		<div class="row">
			<div class="col-sm-12">
				<div class="row">
					<div class="table-footer">
						<div class="col-xs-6 col-sm-3">
							<div id="status-bar" class="status-bar"></div>
						</div>
						<div class="col-xs-12 col-sm-6">
							<div id="pager" class="pager"></div>
						</div>
						<div class="col-sm-3">
							<div id="pagerSize" class="page-sizer-container"></div>
						</div>
					</div>
				</div>
			</div>
		</div>

		<div id="context-menu" class="context-menu">
			<ul class="dropdown-menu" role="menu">
				<li><a tabindex="-1">{{ $t('edit.company.roles') }}</a></li>
				<li><a tabindex="-1">{{ $t('remove.company.roles') }}</a></li>
			</ul>
		</div>
	</div>
</template>

<script>
import { CONFIGURATIONS_PERMISSIONS } from 'actions/configurations'
import { USER_CONFIG } from 'actions/user'
import { CompanyRolesManager } from '@/core/administration/CompanyRolesManager'
import { resizeTableHeight, Table, toggleSearchForm } from '@/core/support_gui_components/table/table'
import { bindResetButton } from '@/core/input_controls/button/button'
import { removeTabindex, showMessageAlert } from '@/core/shared'
import { setToolbarMode } from '@/core/support_gui_components/table/table_toolbar'
import { initFilterForm } from '@/core/filters/filtersSupport'
import { enableMulticheckboxSupport } from '@/core/input_controls/multicheckbox/multicheckbox'
import { enableHotkeyForSearch } from '@/core/hotkey/HotkeyFunctions'

export default {
	name: 'GlobalRoles',
	metaInfo () {
		return {
			title: this.$t('roles')
		}
	},
	methods: {
		getPermissions: function () {
			let vm = this
			this.$store.dispatch(CONFIGURATIONS_PERMISSIONS)
			.then((perm) => {
				vm.initGlobalCompanyRoles(perm)
			})
		},
		initGlobalCompanyRoles: function () {
			let vm = this
			let tableColumns = [
				{
					'checkbox': true
				},
				{
					'title': 'name',
					'columnName': 'name',
					'attribute': 'name'
				},
				{
					'title': 'description',
					'columnName': 'description',
					'attribute': 'description'
				}
			]

			window.itemStructure = {
				'phase': { 'type': 'S' }
			}

			window.manager = new CompanyRolesManager()

			this.$store.dispatch(USER_CONFIG, 'personUsersTable.tableState')
				.then((config) => {
					window.table = new Table('personUsersTable', {
							selector: '#table',
							columns: tableColumns,
							dynamicLoading: true,
							contextMenu: '#context-menu',
							doubleClickMode: 'edit',
							sortingSupport: true,
							cellsSelectionsSupport: true,
							itemsSelectionsSupport: true,
							frozenFirstColumn: true,
							restoringSupport: true,
							filterPreProcessor: function (filter) {
								var newFilter = {}
								for (var fieldName in filter) {
									newFilter[fieldName] = filter[fieldName]['val']
								}
								return newFilter
							}
						},
						{
							contextMenu: {
								1: function (item, attribute) {
									vm.initUserGroupManager('edit', item, attribute)
								},
								2: function (item) {
									manager.initRemoveUserGroupManager(item)
								}
							},
							doubleClick: {
								'edit': function (item, table) {
									table.callbacks.contextMenu['1'](item, table.selectedAttribute)
								}
							}
						})
					table.setSavedState(config)
					table.setDataUrl(window.urlContext + 'roles/load')
					table.setDataIDsUrl(window.urlContext + 'roles/ids')
					table.setDataSortUrl(window.urlContext + 'roles/sort')
					table.initTable()

					bindResetButton()
					removeTabindex()

					setToolbarMode(table.selectedItemsMode)
					initFilterForm(itemStructure, table)
					enableMulticheckboxSupport({ selector: '.multicheckbox-filter' })
					enableHotkeyForSearch(itemStructure, table)
				})
				.catch(error => {
					console.log(error)
					this.rollbar.error('USER_CONFIG personUsersTable', error)
				})

			// toolbar buttons
			$('#table_toolbar_search').bind('click', toggleSearchForm)
			$('#roles_table_toolbar_add').click(function () {
				vm.initUserGroupManager('create', {}, '')
			})
			$('#roles_table_toolbar_remove').bind('click', function () {
				var ids = table.selectedItemsManager.getSelections()
				if (_.isEmpty(ids)) {
					showMessageAlert(vm.$t('no.selected.roles'), 'warning')
				} else {
					manager.initRemoveGroupsManager(ids)
				}
			})

			$(window).resize(function () {
				resizeTableHeight()
				table.frozenTableElements.setFrozenHeaderCellsWidth()
				table.frozenTableElements.setFrozenColumnCellsHeight()
			})
		},
		initUserGroupManager: function (action, item, activeAttribute) {
			let vm = this
			manager.setProperties({
				global: true,
				action: action,
				roleId: item.id,
				activeAttribute: activeAttribute,
				userGroup: item || {},
				allPermissions: vm.$store.getters.getPermissionsList || [],
				rolePermissions: null,
				postSaveAction: function () {
					table.initTable()
				}
			})
			manager.openUserGroupModal(action)
		}
	},
	mounted () {
		this.getPermissions()
	}
}
</script>

<style scoped>

</style>
